import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import AgConvergeAgendaPDF from '../assets/AgConverge_2026_Agenda.pdf';

import CarouselImg from '../images/Carousel.jpg';
import Carousel1Img from '../images/Carousel1.jpg';
import Carousel4Img from '../images/Carousel4.jpg';
import Carousel5Img from '../images/Carousel5.jpg';
import Carousel6Img from '../images/Carousel6.jpg';


const REGISTRATION_URL =
  'https://cvent.me/9E05M7';

const FTAC_STARTUP_URL =
  'https://forms.cloud.microsoft/pages/responsepage.aspx?id=xAPQGhOJLkyxIGKu-ItszRXzT9VQp_xNskPnO7MBrzxUQ0JJR0pIR01ZSlZIMzRXV0VPS0hJWEVaTy4u&route=shorturl';

const STUDENT_REGISTRATION_URL =
  'https://forms.cloud.microsoft/pages/responsepage.aspx?id=xAPQGhOJLkyxIGKu-ItszRXzT9VQp_xNskPnO7MBrzxUNURaN1haQUs2NEI3UlZBQkJOREtIOU05WS4u&route=shorturl';


/* =========================================================
   KEYNOTE SPEAKER PLACEHOLDER
   Replace with real speaker photos when confirmed
   ========================================================= */

const SPEAKER_PLACEHOLDER =
  'data:image/svg+xml;charset=UTF-8,' +
  encodeURIComponent(`
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="400"
      height="400"
      viewBox="0 0 400 400"
    >
      <defs>
        <linearGradient
          id="speakerBg"
          x1="0"
          y1="0"
          x2="1"
          y2="1"
        >
          <stop
            offset="0%"
            stop-color="#edf3e9"
          />
          <stop
            offset="100%"
            stop-color="#dce8d4"
          />
        </linearGradient>
      </defs>

      <rect
        width="400"
        height="400"
        fill="url(#speakerBg)"
      />

      <circle
        cx="200"
        cy="145"
        r="72"
        fill="#91a985"
      />

      <path
        d="
          M75 390
          C85 285 135 230 200 230
          C265 230 315 285 325 390
          Z
        "
        fill="#557649"
      />

      <circle
        cx="200"
        cy="200"
        r="188"
        fill="none"
        stroke="#ffffff"
        stroke-width="12"
        opacity="0.7"
      />
    </svg>
  `);


/* =========================================================
   SESSION LEADERSHIP DIRECTORY

   Add confirmed email/phone information here later.
   ========================================================= */

const peopleDirectory = {

  'Ankit Chandra': {
    name: 'Ankit Chandra',
    email: 'achandra@unl.edu',
    phone: '+1-402-853-9050',
  },

  'Kate Engel': {
    name: 'Kate Engel',
  },

  'Hollie Mackey': {
    name: 'Hollie Mackey',
  },

  'Allison Wekman': {
    name: 'Allison Wekman',
  },

  'Joy Eakin': {
    name: 'Joy Eakin',
  },

  'Nick Bittner': {
    name: 'Nick Bittner',
  },

  'Ishani Lal': {
    name: 'Ishani Lal',
  },

  'Alexa Davis': {
    name: 'Alexa Davis',
  },

  'Ryan Anderson': {
    name: 'Ryan Anderson',
  },

  'Zane Gernhart': {
    name: 'Zane Gernhart',
  },

  'Santosh Pitla': {
    name: 'Santosh Pitla',
  },

  'Amlan Balabantaray': {
    name: 'Amlan Balabantaray',
  },

};


/* =========================================================
   SESSION CHAIRS / CO-CHAIRS
   ========================================================= */

const sessionLeadership = {

  'Welcome & Framing the Two Days': {
    chair: 'Ankit Chandra',
    coChair: 'Kate Engel',
  },

  'Opening Address': {
    chair: 'Ankit Chandra',
    coChair: 'Kate Engel',
  },

  'Producer Keynote': {
    chair: 'Hollie Mackey',
    coChair: 'Allison Wekman',
  },

  'Lunch & Industry Keynote': {
    chair: 'Sponsor representative',
    coChair: null,
    status: 'Chair to be finalized',
  },

  'FTAC Phase 1: Startup Showcase': {
    chair: 'Ankit Chandra',
    coChair: null,
  },

  'Track A: FTAC Phase 2 — Farmer Evaluation Roundtables': {
    chair: 'Joy Eakin',
    coChair: 'Ankit Chandra',
  },

  'FTAC Phase 3: Producer Verdict & Farm Awards': {
    chair: 'Joy Eakin',
    coChair: 'Ankit Chandra',
  },

  'Founder × Farmer Fireside Chat I': {
    chair: 'Ankit Chandra',
    coChair: 'Nick Bittner',
  },

  'Founder × Farmer Fireside Chat II': {
    chair: 'Ankit Chandra',
    coChair: 'Nick Bittner',
  },

  'Women in Midwest AgTech': {
    chair: 'Ishani Lal',
    coChair: 'Alexa Davis',
  },

  'Track B: Industry–Academia Partnership Panel': {
    chair: 'Ryan Anderson',
    coChair: 'Ankit Chandra',
  },

  'Bio-economy Panel': {
    chair: 'Zane Gernhart',
    coChair: null,
  },

  'Networking Reception & Student Poster Session': {
    chair: 'Ishani Lal',
    coChair: 'Alexa Davis',

    secondaryLabel: 'Networking',
    secondaryChair: 'Ryan Anderson',
    secondaryCoChair: 'Ankit Chandra',
  },

  'Closing Address': {
    chair: 'Ankit Chandra',
    coChair: 'Kate Engel',
  },

  'Farewell': {
    chair: 'Ankit Chandra',
    coChair: 'Kate Engel',
  },

};


/* =========================================================
   HOTEL OPTIONS
   ========================================================= */

const hotelOptions = [

  {
    name: 'Grand Island Casino Resort',

    label:
      'Official AgConverge Hotel',

    address:
      '777 E. Fonner Park Road, Grand Island, NE 68801',

    phone:
      '(308) 675-5600',

    description:
      'Located directly at Fonner Park, Grand Island Casino Resort is the official hotel for Spur AgConverge 2026 attendees.',

    url:
      'https://www.grandislandresort.com/hotel.html',

    isOfficialBlock: true,

    specialRate:
      '$119.95/night',

    groupCode:
      '10300N',

    bookBy:
      'October 16, 2026',

    blockMessage:
      'Use group code 10300N when booking your room to receive the special AgConverge rate. The discounted room block is subject to availability.',
  },


  {
    name:
      'Travelodge by Wyndham Grand Island',

    label:
      'Adjacent to Fonner Park',

    address:
      '1311 S. Locust Street, Grand Island, NE 68801',

    phone:
      '(308) 594-0123',

    description:
      'A convenient budget-friendly hotel adjacent to Fonner Park and close to the Heartland Events Center. Amenities include free Wi-Fi, free parking, pet-friendly rooms, and airport shuttle service.',

    url:
      'https://www.wyndhamhotels.com/travelodge/grand-island-nebraska/grand-island-travelodge/overview',
  },


  {
    name:
      'SureStay Plus Hotel by Best Western Grand Island',

    label:
      'About 0.5 mile from Fonner Park',

    address:
      '2603 S. Locust Street, Grand Island, NE 68801',

    phone:
      '(308) 384-4380',

    description:
      'A nearby hotel on South Locust Street within easy reach of Fonner Park. Guests have access to complimentary breakfast, Wi-Fi, an indoor pool, fitness facilities, and free parking.',

    url:
      'https://www.bestwestern.com/en_US/book/hotel-rooms.54219.html',
  },


  {
    name:
      'Island Inn',

    label:
      'Near Fonner Park',

    address:
      '2311 S. Locust Street, Grand Island, NE 68801',

    phone:
      '(308) 382-1815',

    description:
      'A simple and affordable lodging option on South Locust Street close to the Fonner Park event area. Rooms include refrigerators, wireless internet, and free local calls.',

    url:
      'http://www.stayislandinn.com',
  },


  {
    name:
      'Best Western Plus Grand Island Inn & Suites',

    label:
      'About 1 mile from the event center',

    address:
      '2707 S. Locust Street, Grand Island, NE 68801',

    phone:
      '(308) 675-5656',

    description:
      'Located minutes from the Heartland Events Center, Fonner Park, and Nebraska State Fairgrounds. Amenities include a full hot breakfast, indoor heated pool, fitness center, Wi-Fi, and free parking.',

    url:
      'https://www.bestwestern.com/en_US/book/grand-island/hotel-rooms/best-western-plus-grand-island-inn-suites/propertyCode.28071.html',
  },


  {
    name:
      'Ramada by Wyndham Midtown Grand Island',

    label:
      'Near Fonner Park',

    address:
      '2503 S. Locust Street, Grand Island, NE 68801',

    phone:
      '(308) 384-1330',

    description:
      'A full-service hotel near the Heartland Events Center and Fonner Park with an indoor pool, on-site dining, conference facilities, breakfast, Wi-Fi, and parking.',

    url:
      'https://www.wyndhamhotels.com/ramada/grand-island-nebraska/ramada-midtown-grand-island/overview',
  },


  {
    name:
      'MainStay Suites Grand Island',

    label:
      'About 1 mile from Fonner Park',

    address:
      '3051 S. Locust Street, Grand Island, NE 68801',

    phone:
      '(308) 646-2091',

    description:
      'An extended-stay hotel near the Nebraska State Fairgrounds and Fonner Park with apartment-style suites, in-room kitchens, complimentary Wi-Fi, breakfast, and parking.',

    url:
      'https://www.choicehotels.com/nebraska/grand-island/mainstay-hotels/ne131',
  },

];


/* =========================================================
   SESSION DATA
   ========================================================= */

const sessionData = {

  day1: [

    {
      icon:
        'fa-mug-hot',

      title:
        'Registration & Coffee',

      desc:
        'Exhibits and Startup Demonstration Stations open.',

      time:
        '8:00 – 9:00 AM',

      type:
        'networking',
    },


    {
      icon:
        'fa-microphone',

      title:
        'Welcome & Framing the Two Days',

      time:
        '9:00 – 9:10 AM',
    },


    {
      icon:
        'fa-bullhorn',

      title:
        'Opening Address',

      desc:
        'Ankit Chandra, Spur Ventures.',

      time:
        '9:10 – 9:25 AM',
    },


    /* =====================================================
       PRODUCER KEYNOTE
       ===================================================== */

    {
      icon:
        'fa-tractor',

      title:
        'Producer Keynote',

      desc:
        'What Farms Need Now: A Producer’s View on AgTech Innovation.',

      time:
        '9:25 – 10:00 AM',

      badge:
        'Keynote',

      type:
        'featured',

      isKeynote:
        true,

      speakerName:
        'Speaker announcement coming soon',

      speakerRole:
        'Producer Keynote Speaker',

      speakerImage:
        SPEAKER_PLACEHOLDER,

      speakerRoute:
        '/agconverge/keynotes/producer-keynote',
    },


    {
      icon:
        'fa-coffee',

      title:
        'Networking Break',

      desc:
        'Startup Demonstration Stations featured.',

      time:
        '10:00 – 10:30 AM',

      type:
        'break',
    },


    {
      icon:
        'fa-rocket',

      title:
        'FTAC Phase 1: Startup Showcase',

      desc:
        'Eight Selected Startups: eight minutes pitch; your potential customers are in the room.',

      time:
        '10:30 – 11:45 AM',

      badge:
        'FTAC Phase 1',

      type:
        'featured',
    },


    {
      icon:
        'fa-people-arrows',

      title:
        'Transition to Lunch',

      desc:
        'Transition from the morning program to lunch.',

      time:
        '11:45 AM – 12:00 PM',

      type:
        'break',
    },


    /* =====================================================
       INDUSTRY KEYNOTE
       ===================================================== */

    {
      icon:
        'fa-utensils',

      title:
        'Lunch & Industry Keynote',

      desc:
        'Where Capital Is Going: Market Conditions and the Future of AgTech Investment. The keynote is scheduled from 12:20–12:45 PM.',

      time:
        '12:00 – 1:00 PM',

      badge:
        'Keynote · Lunch',

      type:
        'meal',

      isKeynote:
        true,

      speakerName:
        'Speaker announcement coming soon',

      speakerRole:
        'Industry Keynote Speaker',

      speakerImage:
        SPEAKER_PLACEHOLDER,

      speakerRoute:
        '/agconverge/keynotes/industry-keynote',
    },


    {
      icon:
        'fa-table',

      title:
        'Track A: FTAC Phase 2 — Farmer Evaluation Roundtables',

      desc:
        'Farmers, founders, and facilitators participate in a closed evaluation session.',

      time:
        '1:00 – 2:15 PM',

      badge:
        'Closed session',

      type:
        'track',
    },


    {
      icon:
        'fa-users',

      title:
        'Track B: Industry–Academia Partnership Panel',

      desc:
        'From Research to Impact. The Industry–Academia Panel runs from 1:05–1:45 PM, followed by open demonstration time until 2:15 PM.',

      time:
        '1:00 – 2:15 PM',

      badge:
        'Open session',

      type:
        'track',
    },


    {
      icon:
        'fa-robot',

      title:
        'Afternoon Break',

      desc:
        'Robotics & Technology Demonstration Arena featured.',

      time:
        '2:15 – 2:45 PM',

      type:
        'break',
    },


    {
      icon:
        'fa-award',

      title:
        'FTAC Phase 3: Producer Verdict & Farm Awards',

      desc:
        'Roundtable reports, judging panel, producer verdicts, and awards presentation.',

      time:
        '2:45 – 3:45 PM',

      badge:
        'FTAC Phase 3',

      type:
        'featured',
    },


    {
      icon:
        'fa-coffee',

      title:
        'Break',

      desc:
        'Short transition before the afternoon fireside chat.',

      time:
        '3:45 – 4:00 PM',

      type:
        'break',
    },


    {
      icon:
        'fa-comments',

      title:
        'Founder × Farmer Fireside Chat I',

      desc:
        'Beyond the Pitch: Start-up and Farmer\'s details coming soon.',

      time:
        '4:00 – 4:40 PM',

      badge:
        'Fireside chat',

      type:
        'featured',
    },


    {
      icon:
        'fa-flag-checkered',

      title:
        'Day 1 Wrap',

      time:
        '4:40 – 4:55 PM',
    },


    {
      icon:
        'fa-handshake',

      title:
        'Networking Reception & Student Poster Session',

      desc:
        'AgConverge Connect partner meetups, student posters, networking, and open exhibits.',

      time:
        '5:00 – 6:30 PM',

      badge:
        'Reception',

      type:
        'networking',
    },

  ],


  day2: [

    {
      icon:
        'fa-chart-line',

      title:
        'Investor–Startup Breakfast',

      desc:
        'Invitation-only breakfast for showcase startups, investors, and corporate venture teams.',

      time:
        '8:00 – 9:00 AM',

      badge:
        'Invitation only',

      type:
        'meal',
    },


    {
      icon:
        'fa-mug-hot',

      title:
        'Coffee & Networking',

      desc:
        'AgConverge Connect partner meetups, open exhibits, and students presenting at their posters.',

      time:
        '8:15 – 9:00 AM',

      badge:
        'Open networking',

      type:
        'networking',
    },


    {
      icon:
        'fa-microphone',

      title:
        'Welcome Back',

      time:
        '9:00 – 9:05 AM',
    },


    {
      icon:
        'fa-comments',

      title:
        'Founder × Farmer Fireside Chat II',

      desc:
        'Start-up and Farmer\'s details coming soon.',

      time:
        '9:05 – 9:40 AM',

      badge:
        'Fireside chat',

      type:
        'featured',
    },


    {
      icon:
        'fa-users',

      title:
        'Women in Midwest AgTech',

      desc:
        'Women Shaping the Future of Agricultural Innovation — moderated panel.',

      time:
        '9:40 – 10:25 AM',

      badge:
        'Panel',

      type:
        'featured',
    },


    {
      icon:
        'fa-robot',

      title:
        'Morning Break',

      desc:
        'Robotics & Technology Demonstration Arena featured.',

      time:
        '10:25 – 10:50 AM',

      type:
        'break',
    },


    {
      icon:
        'fa-leaf',

      title:
        'Bio-economy Panel',

      desc:
        'From Commodity to Bioproduct: Building the Regional Bio-economy.',

      time:
        '10:50 – 11:35 AM',

      badge:
        'Panel',

      type:
        'featured',
    },


    {
      icon:
        'fa-bullhorn',

      title:
        'Closing Address',

      desc:
        'Ankit Chandra, Spur Ventures.',

      time:
        '11:35 – 11:50 AM',
    },


    {
      icon:
        'fa-flag-checkered',

      title:
        'Farewell',

      time:
        '11:50 AM – 12:00 PM',
    },


    {
      icon:
        'fa-utensils',

      title:
        'Networking Lunch & Departures',

      desc:
        'Continue conversations over lunch before departing.',

      time:
        '12:00 PM',

      badge:
        'Optional',

      type:
        'meal',
    },

  ],

};


/* =========================================================
   DAY TABS
   ========================================================= */

const tabs = [

  {
    key:
      'day1',

    day:
      'Day 1',

    date:
      'Tuesday, November 17',
  },

  {
    key:
      'day2',

    day:
      'Day 2',

    date:
      'Wednesday, November 18',
  },

];


/* =========================================================
   SPUR 2025 HIGHLIGHT IMAGES
   ========================================================= */

const heroSlides = [

  {
    image:
      CarouselImg,

    alt:
      'Spur Ventures event',

    label:
      '2025 Highlight 01',

    position:
      'center',
  },


  {
    image:
      Carousel1Img,

    alt:
      'Spur Ventures conference gathering',

    label:
      '2025 Highlight 02',

    position:
      'center',
  },


  {
    image:
      Carousel4Img,

    alt:
      'Agricultural innovation event',

    label:
      '2025 Highlight 03',

    position:
      'center',
  },


  {
    image:
      Carousel5Img,

    alt:
      'AgTech networking event',

    label:
      '2025 Highlight 04',

    position:
      'center',
  },


  {
    image:
      Carousel6Img,

    alt:
      'Spur Ventures community event',

    label:
      '2025 Highlight 05',

    position:
      'center',
  },

];


/* =========================================================
   COMPONENT
   ========================================================= */

const HarvestHorizonHero = ({

  timeLeft = {
    days: '--',
    hours: '--',
    minutes: '--',
  },

}) => {


  const navigate =
    useNavigate();


  const [activeTab, setActiveTab] =
    useState('day1');


  const [
    heroSlideIndex,
    setHeroSlideIndex,
  ] = useState(0);


  /* =========================================================
     HERO CAROUSEL AUTO ROTATION
     ========================================================= */

  useEffect(() => {

    const heroInterval =
      window.setInterval(() => {

        setHeroSlideIndex(
          (current) =>
            current ===
              heroSlides.length - 1

              ? 0

              : current + 1
        );

      }, 5000);


    return () => {

      window.clearInterval(
        heroInterval
      );

    };

  }, []);


  const previousHeroSlide = () => {

    setHeroSlideIndex(
      (current) =>
        current === 0

          ? heroSlides.length - 1

          : current - 1
    );

  };


  const nextHeroSlide = () => {

    setHeroSlideIndex(
      (current) =>
        current ===
          heroSlides.length - 1

          ? 0

          : current + 1
    );

  };


  const openRegistration = () => {

    window.open(
      REGISTRATION_URL,
      '_blank',
      'noopener,noreferrer'
    );

  };


  return (

    <>

      {/* =====================================================
          SPUR 2025 HIGHLIGHTS CAROUSEL
          ===================================================== */}

      <section
        className="
          hh-hero
          hh-image-hero
          hh-carousel-hero
        "
        aria-label="Spur 2025 Highlights"
      >


        <div className="hh-carousel-slides">

          {heroSlides.map(
            (slide, index) => (

              <div
                key={slide.label}

                className={`hh-carousel-slide ${index ===
                  heroSlideIndex

                  ? 'active'

                  : ''
                  }`}

                aria-hidden={
                  index !==
                  heroSlideIndex
                }
              >

                <img
                  src={slide.image}

                  alt={slide.alt}

                  className="
                    hh-image-hero-img
                  "

                  style={{
                    objectPosition:
                      slide.position,
                  }}
                />

              </div>

            )
          )}

        </div>


        {/* PHOTO OVERLAY */}

        <div
          className="
            hh-carousel-photo-overlay
          "
        />


        {/* HEADING */}

        <div
          className="
            hh-carousel-highlight-label
          "
        >

          <span>
            Spur AgConverge
          </span>

          <strong>
            2025 Highlights
          </strong>

        </div>


        {/* REGISTER + PROGRAMME */}

        <div
          className="
            hh-image-hero-actions
          "
        >

          <a
            href={REGISTRATION_URL}

            target="_blank"

            rel="noopener noreferrer"

            className="
              hh-image-hero-btn
              hh-image-hero-btn-primary
            "
          >
            Register Now

            <i
              className="
                fas
                fa-arrow-right
              "
            />
          </a>


          <a
            href="#agenda"

            className="
              hh-image-hero-btn
              hh-image-hero-btn-secondary
            "
          >
            View Programme

            <i
              className="
                far
                fa-calendar-alt
              "
            />
          </a>

        </div>


        {/* PREVIOUS */}

        <button
          type="button"

          className="
            hh-carousel-arrow
            hh-carousel-arrow-left
          "

          onClick={
            previousHeroSlide
          }

          aria-label="
            Previous AgConverge highlight
          "
        >
          <i
            className="
              fas
              fa-chevron-left
            "
          />
        </button>


        {/* NEXT */}

        <button
          type="button"

          className="
            hh-carousel-arrow
            hh-carousel-arrow-right
          "

          onClick={
            nextHeroSlide
          }

          aria-label="
            Next AgConverge highlight
          "
        >
          <i
            className="
              fas
              fa-chevron-right
            "
          />
        </button>


        {/* DOTS */}

        <div
          className="
            hh-carousel-dots
          "

          aria-label="
            AgConverge carousel navigation
          "
        >

          {heroSlides.map(
            (slide, index) => (

              <button
                type="button"

                key={slide.label}

                className={`hh-carousel-dot ${index ===
                  heroSlideIndex

                  ? 'active'

                  : ''
                  }`}

                onClick={() =>
                  setHeroSlideIndex(
                    index
                  )
                }

                aria-label={`Show ${slide.label}`}

                aria-current={
                  index ===
                    heroSlideIndex

                    ? 'true'

                    : undefined
                }
              />

            )
          )}

        </div>

      </section>


      {/* =====================================================
          STATS
          ===================================================== */}

      <div className="s-stats">

        <div className="s-stats-inner">


          <div className="s-stat">

            <span className="n">
              8
            </span>

            <span className="l">
              Global startups
            </span>

          </div>


          <div className="s-stat">

            <span className="n">
              $1000
            </span>

            <span className="l">
              Student poster award
            </span>

          </div>


          <div className="s-stat">

            <span className="n">
              2
            </span>

            <span className="l">
              Conference days
            </span>

          </div>


          <div className="s-stat">

            <span className="n">
              $6000
            </span>

            <span className="l">
              In Farm Awards
            </span>

          </div>

        </div>

      </div>


      {/* =====================================================
          COUNTDOWN
          ===================================================== */}

      <div className="s-countdown">

        <div className="s-countdown-inner">

          <span
            className="
              s-countdown-label
            "
          >
            Countdown
          </span>


          <div
            className="
              s-countdown-units
            "
          >


            <div className="s-cu">

              <span className="n">
                {timeLeft.days}
              </span>

              <span className="l">
                Days
              </span>

            </div>


            <div className="s-cu">

              <span className="n">
                {timeLeft.hours}
              </span>

              <span className="l">
                Hrs
              </span>

            </div>


            <div className="s-cu">

              <span className="n">
                {timeLeft.minutes}
              </span>

              <span className="l">
                Min
              </span>

            </div>

          </div>

        </div>

      </div>


      {/* =====================================================
          WHY AGCONVERGE EXISTS
          ===================================================== */}

      <div className="s-narrative">


        <div className="s-narrative-left">

          <h2>
            Why AgConverge exists
          </h2>


          <p>
            Agriculture does not lack innovation. Every year,
            entrepreneurs launch new technologies, researchers
            generate breakthrough discoveries, and investors
            deploy capital into promising ventures. Yet many
            innovations never make it onto farms and ranches.
            Some are looking for the right customer. Others
            need additional validation. Some solve problems
            that farmers do not actually have. Many simply
            struggle to move beyond pilot projects and early
            adopters. Spur AgConverge was created to help close
            that gap.
          </p>


          <div className="s-pullquote">

            <p>
              “Adoption happens when farmers help shape
              innovation from the beginning — not after
              the pitch deck is done.”
            </p>

          </div>


          <p>
            AgConverge is focused on strengthening the
            entrepreneurial innovation ecosystem across
            agriculture, animal health, food systems, and
            climate technologies throughout Nebraska and
            the Midwest. The conference serves as a platform
            where ideas are tested, partnerships are formed,
            and technologies move closer to real-world
            adoption and impact.
          </p>

        </div>


        {/* RIGHT SIDE */}

        <div className="s-pillar-columns">


          <div
            className="
              s-pillar-main-column
            "
          >


            <div className="s-pillar">

              <div className="s-pillar-dot">
                <i className="fas fa-seedling" />
              </div>

              <div>

                <h3>
                  Farmer-led validation
                </h3>

                <p>
                  Producers evaluate technologies
                  against real operational challenges —
                  economics, implementation, and fit.
                </p>

              </div>

            </div>


            <div className="s-pillar">

              <div className="s-pillar-dot">
                <i className="fas fa-flask" />
              </div>

              <div>

                <h3>
                  Real-world environments
                </h3>

                <p>
                  Entrepreneurs gain access to
                  on-farm testing through the Spur
                  Validation Sandbox Program.
                </p>

              </div>

            </div>


            <div className="s-pillar">

              <div className="s-pillar-dot">
                <i className="fas fa-school" />
              </div>

              <div>

                <h3>
                  Research partnerships
                </h3>

                <p>
                  Industry and academia collaborate
                  to reduce technical risk and
                  accelerate commercialization.
                </p>

              </div>

            </div>


            <div className="s-pillar">

              <div className="s-pillar-dot">
                <i className="fas fa-coins" />
              </div>

              <div>

                <h3>
                  Capital pathways
                </h3>

                <p>
                  Investors gain clearer signals of
                  market demand and adoption potential
                  from farmer verdicts.
                </p>

              </div>

            </div>

          </div>


          <div
            className="
              s-pillar-divider
            "
            aria-hidden="true"
          />


          {/* REGISTRATION */}

          <div
            className="
              s-ftac-resource-column
            "
          >

            <div className="s-pillar">

              <div className="s-pillar-dot">
                <i className="fas fa-rocket" />
              </div>


              <div
                className="
                  s-ftac-resource-content
                "
              >

                <h3>
                  Registration
                </h3>


                <p>
                  Startup registration, student
                  registration, agenda, and awards
                  information.
                </p>


                {/* STARTUP */}

                <details
                  className="
                    s-resource-dropdown
                    s-resource-dropdown--startup
                  "
                >

                  <summary>

                    <span
                      className="
                        s-resource-summary-left
                      "
                    >

                      <span
                        className="
                          s-resource-icon
                        "
                      >
                        <i
                          className="
                            fas
                            fa-rocket
                          "
                        />
                      </span>

                      <span
                        className="
                          s-resource-summary-text
                        "
                      >
                        <span className="title">
                          Startup Registration
                        </span>
                      </span>

                    </span>

                    <i
                      className="
                        fas
                        fa-chevron-down
                        s-resource-arrow
                      "
                    />

                  </summary>


                  <div
                    className="
                      s-resource-dropdown-body
                    "
                  >

                    <p>
                      Register your startup for the
                      Farmer Tech Adoption Challenge
                      at Spur AgConverge 2026.
                    </p>

                    <a
                      href={
                        FTAC_STARTUP_URL
                      }
                      target="_blank"
                      rel="noopener noreferrer"
                      className="
                        s-resource-link
                      "
                    >
                      Register Startup

                      <i
                        className="
                          fas
                          fa-external-link-alt
                        "
                      />
                    </a>

                  </div>

                </details>


                {/* STUDENT */}

                <details
                  className="
                    s-resource-dropdown
                    s-resource-dropdown--student
                  "
                >

                  <summary>

                    <span
                      className="
                        s-resource-summary-left
                      "
                    >

                      <span
                        className="
                          s-resource-icon
                        "
                      >
                        <i
                          className="
                            fas
                            fa-user-graduate
                          "
                        />
                      </span>

                      <span
                        className="
                          s-resource-summary-text
                        "
                      >
                        <span className="title">
                          Student Registration
                        </span>
                      </span>

                    </span>

                    <i
                      className="
                        fas
                        fa-chevron-down
                        s-resource-arrow
                      "
                    />

                  </summary>


                  <div
                    className="
                      s-resource-dropdown-body
                    "
                  >

                    <p>
                      Students, register to attend
                      and take part in the Student
                      Poster Session at Spur
                      AgConverge 2026.
                    </p>

                    <a
                      href={
                        STUDENT_REGISTRATION_URL
                      }
                      target="_blank"
                      rel="noopener noreferrer"
                      className="
                        s-resource-link
                      "
                    >
                      Register as a Student

                      <i
                        className="
                          fas
                          fa-external-link-alt
                        "
                      />
                    </a>

                  </div>

                </details>


                {/* AGENDA */}

                <details
                  className="
                    s-resource-dropdown
                    s-resource-dropdown--agenda
                  "
                >

                  <summary>

                    <span
                      className="
                        s-resource-summary-left
                      "
                    >

                      <span
                        className="
                          s-resource-icon
                        "
                      >
                        <i
                          className="
                            far
                            fa-calendar-alt
                          "
                        />
                      </span>

                      <span
                        className="
                          s-resource-summary-text
                        "
                      >
                        <span className="title">
                          AgConverge 2026 Agenda
                        </span>
                      </span>

                    </span>

                    <i
                      className="
                        fas
                        fa-chevron-down
                        s-resource-arrow
                      "
                    />

                  </summary>


                  <div
                    className="
                      s-resource-dropdown-body
                    "
                  >

                    <p>
                      Download the full
                      November 17–18, 2026
                      conference agenda.
                    </p>

                    <a
                      href={
                        AgConvergeAgendaPDF
                      }
                      download="
                        Spur_AgConverge_2026_Agenda.pdf
                      "
                      className="
                        s-resource-link
                      "
                    >
                      Download Agenda

                      <i
                        className="
                          fas
                          fa-download
                        "
                      />
                    </a>

                  </div>

                </details>


                {/* AWARDS */}

                <details
                  className="
                    s-resource-dropdown
                    s-resource-dropdown--awards
                  "
                >

                  <summary>

                    <span
                      className="
                        s-resource-summary-left
                      "
                    >

                      <span
                        className="
                          s-resource-icon
                        "
                      >
                        <i
                          className="
                            fas
                            fa-trophy
                          "
                        />
                      </span>

                      <span
                        className="
                          s-resource-summary-text
                        "
                      >
                        <span className="title">
                          Awards
                        </span>
                      </span>

                    </span>

                    <i
                      className="
                        fas
                        fa-chevron-down
                        s-resource-arrow
                      "
                    />

                  </summary>


                  <div
                    className="
                      s-resource-dropdown-body
                    "
                  >

                    <p>
                      $5,000 in Farm Awards
                      presented to the top farmer
                      roundtables during FTAC
                      Phase 3: Producer Verdict
                      &amp; Farm Awards.
                    </p>

                    <a
                      href={
                        REGISTRATION_URL
                      }
                      target="_blank"
                      rel="noopener noreferrer"
                      className="
                        s-resource-link
                      "
                    >
                      Register Now

                      <i
                        className="
                          fas
                          fa-external-link-alt
                        "
                      />
                    </a>

                  </div>

                </details>

              </div>

            </div>

          </div>

        </div>

      </div>


      {/* =====================================================
          SESSIONS EXPLORER
          ===================================================== */}

      <section
        className="s-sessions"
        id="agenda"
      >

        <div
          className="
            s-agenda-hero
          "
        >

          <div
            className="
              s-agenda-heading
            "
          >

            <span
              className="
                s-agenda-kicker
              "
            >
              Spur AgConverge 2026
            </span>


            <h2>
              Sessions Explorer
            </h2>


            <p>
              Explore two days of keynotes,
              farmer-led technology evaluation,
              panels, demonstrations, networking,
              and conversations designed to move
              AgTech toward real-world adoption.
            </p>

          </div>


          <div
            className="
              s-agenda-meta
            "
          >

            <div
              className="
                s-agenda-meta-item
              "
            >

              <div
                className="
                  s-agenda-meta-icon
                "
              >
                <i
                  className="
                    far
                    fa-calendar
                  "
                />
              </div>

              <div>

                <span>
                  Date
                </span>

                <strong>
                  November 17–18, 2026
                </strong>

              </div>

            </div>


            <div
              className="
                s-agenda-meta-item
              "
            >

              <div
                className="
                  s-agenda-meta-icon
                "
              >
                <i
                  className="
                    fas
                    fa-map-marker-alt
                  "
                />
              </div>

              <div>

                <span>
                  Location
                </span>

                <strong>
                  Raising Nebraska
                </strong>

                <small>
                  Grand Island, Nebraska
                </small>

              </div>

            </div>

          </div>

        </div>


        {/* DAY TABS */}

        <div
          className="
            s-session-tabs
          "
          role="tablist"
          aria-label="
            Conference agenda days
          "
        >

          {tabs.map(
            (tab) => (

              <button
                type="button"

                role="tab"

                id={`${tab.key}-tab`}

                key={tab.key}

                className={`s-stab ${activeTab ===
                  tab.key

                  ? 'act'

                  : ''
                  }`}

                onClick={() =>
                  setActiveTab(
                    tab.key
                  )
                }

                aria-selected={
                  activeTab ===
                  tab.key
                }

                aria-controls={`${tab.key}-panel`}
              >

                <span
                  className="
                    s-stab-day
                  "
                >
                  {tab.day}
                </span>

                <span
                  className="
                    s-stab-date
                  "
                >
                  {tab.date}
                </span>

              </button>

            )
          )}

        </div>


        {/* SESSION CONTENT */}

        <div
          className="
            s-session-content
          "

          id={`${activeTab}-panel`}

          role="tabpanel"

          aria-labelledby={`${activeTab}-tab`}
        >

          <div
            className="
              s-agenda-day-header
            "
          >

            <div>

              <span
                className="
                  s-agenda-day-label
                "
              >
                {
                  activeTab === 'day1'

                    ? 'Tuesday'

                    : 'Wednesday'
                }
              </span>

              <h3>
                {
                  activeTab === 'day1'

                    ? 'November 17, 2026'

                    : 'November 18, 2026'
                }
              </h3>

            </div>


            <div
              className="
                s-agenda-count
              "
            >
              {
                sessionData[
                  activeTab
                ].length
              }

              {' '}

              agenda items
            </div>

          </div>


          <div
            className="
              s-scontent
              act
            "
          >

            {
              sessionData[
                activeTab
              ].map((session) => {


                const leadership =
                  sessionLeadership[
                  session.title
                  ];


                const chair =
                  leadership?.chair

                    ? peopleDirectory[
                    leadership.chair
                    ]

                    : null;


                const coChair =
                  leadership?.coChair

                    ? peopleDirectory[
                    leadership.coChair
                    ]

                    : null;


                return (

                  <article

                    key={
                      `${session.time}-${session.title}`
                    }


                    className={`s-scard ${session.type

                      ? `is-${session.type}`

                      : ''
                      } ${session.isKeynote

                        ? 's-scard-keynote'

                        : ''
                      }`}


                    onClick={
                      session.speakerRoute

                        ? () =>
                          navigate(
                            session.speakerRoute
                          )

                        : undefined
                    }


                    onKeyDown={
                      session.speakerRoute

                        ? (event) => {

                          if (
                            event.key ===
                            'Enter' ||

                            event.key ===
                            ' '
                          ) {

                            event.preventDefault();

                            navigate(
                              session.speakerRoute
                            );

                          }

                        }

                        : undefined
                    }


                    role={
                      session.speakerRoute

                        ? 'link'

                        : undefined
                    }


                    tabIndex={
                      session.speakerRoute

                        ? 0

                        : undefined
                    }

                  >


                    {/* TIME */}

                    <div
                      className="
                        s-scard-time-column
                      "
                    >

                      <span
                        className="
                          s-scard-time
                        "
                      >
                        {session.time}
                      </span>


                      {session.isKeynote && (

                        <span
                          className="
                            s-keynote-featured-label
                          "
                        >
                          Featured
                        </span>

                      )}

                    </div>


                    {/* ICON */}

                    <div
                      className={`s-scard-icon ${session.isKeynote

                        ? 's-keynote-session-icon'

                        : ''
                        }`}
                    >

                      <i
                        className={`fas ${session.icon}`}
                      />

                    </div>


                    {/* DETAILS */}

                    <div
                      className="
                        s-scard-details
                      "
                    >

                      <div
                        className="
                          s-scard-heading
                        "
                      >

                        <h3>
                          {session.title}
                        </h3>


                        {session.badge && (

                          <span
                            className={`s-session-badge ${session.isKeynote

                              ? 's-keynote-badge'

                              : ''
                              }`}
                          >
                            {session.badge}
                          </span>

                        )}

                      </div>


                      {session.desc && (

                        <p>
                          {session.desc}
                        </p>

                      )}


                      {/* KEYNOTE SPEAKER */}

                      {session.isKeynote && (

                        <div
                          className="
                            s-keynote-speaker-meta
                          "
                        >

                          <span>
                            Keynote Speaker
                          </span>

                          <strong>
                            {
                              session.speakerName
                            }
                          </strong>

                        </div>

                      )}


                      {/* SESSION LEADERSHIP */}

                      {leadership && (

                        <div
                          className="
                            s-session-leadership
                          "
                        >

                          <div
                            className="
                              s-session-leadership-label
                            "
                          >

                            <i
                              className="
                                fas
                                fa-user-friends
                              "
                            />

                            Session Leadership

                          </div>


                          <div
                            className="
                              s-session-leadership-people
                            "
                          >


                            {/* CHAIR */}

                            <div
                              className="
                                s-session-leader
                              "
                            >

                              <span>
                                Chair
                              </span>

                              <strong>
                                {
                                  leadership.chair
                                }
                              </strong>


                              {chair?.email && (

                                <div
                                  className="
                                    s-session-leader-contact
                                  "
                                >

                                  <a
                                    href={`mailto:${chair.email}`}

                                    onClick={
                                      (
                                        event
                                      ) =>
                                        event
                                          .stopPropagation()
                                    }
                                  >

                                    <i
                                      className="
                                        fas
                                        fa-envelope
                                      "
                                    />

                                    {
                                      chair.email
                                    }

                                  </a>


                                  {chair.phone && (

                                    <a
                                      href={`tel:${chair.phone.replace(
                                        /[^+\d]/g,
                                        ''
                                      )}`}

                                      onClick={
                                        (
                                          event
                                        ) =>
                                          event
                                            .stopPropagation()
                                      }
                                    >

                                      <i
                                        className="
                                          fas
                                          fa-phone
                                        "
                                      />

                                      {
                                        chair.phone
                                      }

                                    </a>

                                  )}

                                </div>

                              )}

                            </div>


                            {/* CO-CHAIR */}

                            {
                              leadership.coChair &&
                              (

                                <div
                                  className="
                                    s-session-leader
                                  "
                                >

                                  <span>
                                    Co-Chair
                                  </span>

                                  <strong>
                                    {
                                      leadership.coChair
                                    }
                                  </strong>


                                  {
                                    coChair?.email &&
                                    (

                                      <div
                                        className="
                                          s-session-leader-contact
                                        "
                                      >

                                        <a
                                          href={`mailto:${coChair.email}`}

                                          onClick={
                                            (
                                              event
                                            ) =>
                                              event
                                                .stopPropagation()
                                          }
                                        >

                                          <i
                                            className="
                                              fas
                                              fa-envelope
                                            "
                                          />

                                          {
                                            coChair.email
                                          }

                                        </a>

                                      </div>

                                    )
                                  }

                                </div>

                              )
                            }


                            {/* SECONDARY TEAM */}

                            {
                              leadership.secondaryChair &&
                              (

                                <div
                                  className="
                                    s-session-leader
                                    s-session-leader-secondary
                                  "
                                >

                                  <span>
                                    {
                                      leadership.secondaryLabel ||
                                      'Additional Lead'
                                    }
                                  </span>

                                  <strong>

                                    {
                                      leadership.secondaryChair
                                    }

                                    {
                                      leadership.secondaryCoChair

                                        ? ` · ${leadership.secondaryCoChair}`

                                        : ''
                                    }

                                  </strong>

                                </div>

                              )
                            }

                          </div>


                          {
                            leadership.status &&
                            (

                              <small
                                className="
                                  s-session-leadership-status
                                "
                              >
                                {
                                  leadership.status
                                }
                              </small>

                            )
                          }

                        </div>

                      )}

                    </div>


                    {/* KEYNOTE PHOTO */}

                    {session.isKeynote && (

                      <div
                        className="
                          s-keynote-portrait-area
                        "
                      >

                        <div
                          className="
                            s-keynote-portrait-glow
                          "
                        />


                        <div
                          className="
                            s-keynote-portrait-frame
                          "
                        >

                          <img
                            src={
                              session.speakerImage
                            }

                            alt={
                              session.speakerName
                            }

                            className="
                              s-keynote-portrait
                            "
                          />

                        </div>


                        <span
                          className="
                            s-keynote-card-arrow
                          "
                        >

                          <i
                            className="
                              fas
                              fa-arrow-right
                            "
                          />

                        </span>

                      </div>

                    )}

                  </article>

                );

              })
            }

          </div>

        </div>

      </section>


      {/* =====================================================
          HOTEL & TRAVEL
          ===================================================== */}

      <section
        className="
          ag-travel-section
        "
        id="travel"
      >

        <div
          className="
            ag-travel-container
          "
        >


          <div
            className="
              ag-travel-header
            "
          >

            <div>

              <span
                className="
                  ag-travel-eyebrow
                "
              >
                Plan Your Visit
              </span>


              <h2>
                Hotel &amp; Travel
                Information
              </h2>

            </div>


            <p>
              Practical information for reaching
              Raising Nebraska, parking at the
              venue, traveling through Grand
              Island, and choosing nearby
              accommodations.
            </p>

          </div>


          <div
            className="
              ag-travel-layout
            "
          >


            {/* TRAVEL COLUMN */}

            <div
              className="
                ag-travel-column
              "
            >

              <div
                className="
                  ag-travel-column-heading
                "
              >

                <span>
                  01
                </span>

                <div>

                  <small>
                    Getting here
                  </small>

                  <h3>
                    Travel to Grand Island
                  </h3>

                </div>

              </div>


              <div
                className="
                  ag-travel-card-list
                "
              >


                {/* VENUE */}

                <article
                  className="
                    ag-travel-card
                  "
                >

                  <div
                    className="
                      ag-travel-icon
                    "
                  >
                    <i
                      className="
                        fas
                        fa-map-marker-alt
                      "
                    />
                  </div>


                  <div>

                    <span
                      className="
                        ag-travel-label
                      "
                    >
                      Conference venue
                    </span>


                    <h4>
                      Raising Nebraska
                    </h4>


                    <p>
                      Nebraska Building at
                      Fonner Park
                      <br />

                      501 E. Fonner Park Road,
                      Suite 100
                      <br />

                      Grand Island,
                      Nebraska 68801
                    </p>


                    <a
                      href="
                        https://www.google.com/maps/search/?api=1&query=Raising+Nebraska+501+E+Fonner+Park+Road+Grand+Island+NE+68801
                      "
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Open directions

                      <i
                        className="
                          fas
                          fa-external-link-alt
                        "
                      />
                    </a>

                  </div>

                </article>


                {/* PARKING */}

                <article
                  className="
                    ag-travel-card
                  "
                >

                  <div
                    className="
                      ag-travel-icon
                    "
                  >
                    <i
                      className="
                        fas
                        fa-car
                      "
                    />
                  </div>


                  <div>

                    <span
                      className="
                        ag-travel-label
                      "
                    >
                      Parking
                    </span>


                    <h4>
                      Free Parking at the
                      Nebraska Building
                    </h4>


                    <p>
                      Free accessible parking
                      is available on the west
                      side of the Nebraska
                      Building. Buses and
                      motorcoaches are encouraged
                      to use the east lot.
                    </p>


                    <a
                      href="https://raisingnebraska.net/visitor-information/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Venue visitor information

                      <i
                        className="
                          fas
                          fa-external-link-alt
                        "
                      />
                    </a>

                  </div>

                </article>


                {/* AIRPORT */}

                <article
                  className="
                    ag-travel-card
                  "
                >

                  <div
                    className="
                      ag-travel-icon
                    "
                  >
                    <i
                      className="
                        fas
                        fa-plane
                      "
                    />
                  </div>


                  <div>

                    <span
                      className="
                        ag-travel-label
                      "
                    >
                      Traveling by air
                    </span>


                    <h4>
                      Central Nebraska
                      Regional Airport
                    </h4>


                    <p>
                      Grand Island&apos;s airport
                      offers nonstop service to
                      Dallas–Fort Worth, Las Vegas,
                      and Phoenix–Mesa. Confirm
                      current schedules directly
                      with the airport and airline
                      before booking.
                    </p>


                    <a
                      href="https://flygrandisland.com/book-now/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      View flight information

                      <i
                        className="
                          fas
                          fa-external-link-alt
                        "
                      />
                    </a>

                  </div>

                </article>


                {/* LOCAL TRANSPORT */}

                <article
                  className="
                    ag-travel-card
                  "
                >

                  <div
                    className="
                      ag-travel-icon
                    "
                  >
                    <i
                      className="
                        fas
                        fa-route
                      "
                    />
                  </div>


                  <div>

                    <span
                      className="
                        ag-travel-label
                      "
                    >
                      Local transportation
                    </span>


                    <h4>
                      Rental Cars, Transit,
                      and Rail
                    </h4>


                    <p>
                      Hertz, Thrifty, and Dollar
                      operate on-site rental-car
                      service at the airport.
                      Grand Island Tourism also
                      lists CRANE public transit,
                      taxi service, and Amtrak
                      service through Hastings.
                    </p>


                    <a
                      href="https://visitgrandisland.com/plan-a-trip/transportation.html"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Explore transportation options

                      <i
                        className="
                          fas
                          fa-external-link-alt
                        "
                      />
                    </a>

                  </div>

                </article>

              </div>

            </div>


            {/* =================================================
                HOTELS
                ================================================= */}

            <div
              className="
                ag-hotel-column
              "
            >

              <div
                className="
                  ag-travel-column-heading
                "
              >

                <span>
                  02
                </span>

                <div>

                  <small>
                    Where to stay
                  </small>

                  <h3>
                    Hotel Options
                  </h3>

                </div>

              </div>


              <div
                className="
                  ag-hotel-list
                "
              >

                {hotelOptions.map(
                  (hotel) => (

                    <article
                      className={`ag-hotel-card ${hotel.isOfficialBlock

                        ? 'ag-hotel-card-official'

                        : ''
                        }`}

                      key={
                        hotel.name
                      }
                    >


                      <div
                        className="
                          ag-hotel-card-top
                        "
                      >

                        <span
                          className={`ag-hotel-tag ${hotel.isOfficialBlock

                            ? 'ag-hotel-tag-official'

                            : ''
                            }`}
                        >

                          {
                            hotel.isOfficialBlock &&
                            (
                              <i
                                className="
                                  fas
                                  fa-star
                                "
                              />
                            )
                          }

                          {hotel.label}

                        </span>


                        <a
                          href={
                            hotel.url
                          }

                          target="_blank"

                          rel="noopener noreferrer"

                          className="
                            ag-hotel-arrow
                          "

                          aria-label={`Visit ${hotel.name} website`}
                        >

                          <i
                            className="
                              fas
                              fa-external-link-alt
                            "
                          />

                        </a>

                      </div>


                      <h4>
                        {hotel.name}
                      </h4>


                      <p
                        className="
                          ag-hotel-address
                        "
                      >

                        <i
                          className="
                            fas
                            fa-map-marker-alt
                          "
                        />

                        <span>
                          {hotel.address}
                        </span>

                      </p>


                      <p
                        className="
                          ag-hotel-phone
                        "
                      >

                        <i
                          className="
                            fas
                            fa-phone
                          "
                        />

                        <span>
                          {hotel.phone}
                        </span>

                      </p>


                      <p
                        className="
                          ag-hotel-description
                        "
                      >
                        {hotel.description}
                      </p>


                      {/* =================================
                          OFFICIAL HOTEL BLOCK
                          ================================= */}

                      {
                        hotel.isOfficialBlock &&
                        (

                          <div
                            className="
                              ag-hotel-block
                            "
                          >


                            <div
                              className="
                                ag-hotel-block-heading
                              "
                            >

                              <div
                                className="
                                  ag-hotel-block-icon
                                "
                              >
                                <i
                                  className="
                                    fas
                                    fa-hotel
                                  "
                                />
                              </div>


                              <div>

                                <span>
                                  Spur AgConverge
                                  2026
                                </span>

                                <strong>
                                  Special Hotel Rate
                                </strong>

                              </div>

                            </div>


                            <div
                              className="
                                ag-hotel-rate
                              "
                            >

                              <strong>
                                {
                                  hotel.specialRate
                                }
                              </strong>

                              <span>
                                Special attendee
                                rate
                              </span>

                            </div>


                            <div
                              className="
                                ag-hotel-block-details
                              "
                            >


                              <div
                                className="
                                  ag-hotel-block-detail
                                "
                              >

                                <span>
                                  Group Code
                                </span>

                                <strong
                                  className="
                                    ag-hotel-code
                                  "
                                >
                                  {
                                    hotel.groupCode
                                  }
                                </strong>

                              </div>


                              <div
                                className="
                                  ag-hotel-block-detail
                                "
                              >

                                <span>
                                  Book By
                                </span>

                                <strong>
                                  {
                                    hotel.bookBy
                                  }
                                </strong>

                              </div>

                            </div>


                            <p
                              className="
                                ag-hotel-block-message
                              "
                            >

                              <i
                                className="
                                  fas
                                  fa-info-circle
                                "
                              />

                              <span>
                                {
                                  hotel.blockMessage
                                }
                              </span>

                            </p>


                            <a
                              href={
                                hotel.url
                              }

                              target="_blank"

                              rel="noopener noreferrer"

                              className="
                                ag-hotel-book-button
                              "
                            >
                              Book Your Hotel Room

                              <i
                                className="
                                  fas
                                  fa-arrow-right
                                "
                              />
                            </a>

                          </div>

                        )
                      }


                      {
                        !hotel.isOfficialBlock &&
                        (

                          <a
                            href={
                              hotel.url
                            }

                            target="_blank"

                            rel="noopener noreferrer"

                            className="
                              ag-hotel-link
                            "
                          >
                            Check availability

                            <i
                              className="
                                fas
                                fa-arrow-right
                              "
                            />
                          </a>

                        )
                      }

                    </article>

                  )
                )}

              </div>


              <div
                className="
                  ag-hotel-note
                "
              >

                <i
                  className="
                    fas
                    fa-info-circle
                  "
                />


                <div>

                  <strong>
                    Booking note
                  </strong>


                  <p>
                    The Grand Island Casino Resort
                    has an official Spur AgConverge
                    2026 room block. Other hotel
                    rates and availability change
                    frequently, so confirm current
                    pricing and cancellation terms
                    directly with each property
                    before booking.
                  </p>

                </div>

              </div>


              <a
                href="https://www.visitgrandisland.com/where-to-stay"

                target="_blank"

                rel="noopener noreferrer"

                className="
                  ag-all-hotels-link
                "
              >
                Browse more Grand Island lodging

                <i
                  className="
                    fas
                    fa-arrow-right
                  "
                />
              </a>

            </div>

          </div>

        </div>

      </section>


      {/* =====================================================
          FARMERS TECH ADOPTION CHALLENGE
          ===================================================== */}

      <div className="s-ftac">

        <div className="s-ftac-inner">

          <h2>
            The Farmers Tech Adoption
            Challenge™
          </h2>


          <p className="sub">
            A first-of-its-kind farmer-led market
            validation platform — the only event
            in agriculture where producers
            evaluate technologies live, on stage,
            in front of investors and industry.
          </p>


          <div
            className="
              s-ftac-track
            "
          >


            <div className="s-fbox">

              <div
                className="
                  s-fbox-phase
                "
              >
                Phase 01
              </div>

              <div
                className="
                  s-fbox-num
                "
              >
                01
              </div>

              <h3>
                Startup Showcase
              </h3>

              <p>
                8 selected startups ·
                8 minutes each · live
                Q&amp;A · technologies
                from across the U.S.
                and the world
              </p>

            </div>


            <div className="s-farrow">
              <i
                className="
                  fas
                  fa-arrow-right
                "
              />
            </div>


            <div
              className="
                s-fbox
                center
              "
            >

              <div
                className="
                  s-fbox-phase
                "
              >
                Phase 02
              </div>

              <div
                className="
                  s-fbox-num
                "
              >
                02
              </div>

              <h3>
                Farmer Roundtables
              </h3>

              <p>
                Producers evaluate each
                technology on economics,
                ease of implementation,
                scalability, and adoption
                likelihood
              </p>

            </div>


            <div className="s-farrow">
              <i
                className="
                  fas
                  fa-arrow-right
                "
              />
            </div>


            <div className="s-fbox">

              <div
                className="
                  s-fbox-phase
                "
              >
                Phase 03
              </div>

              <div
                className="
                  s-fbox-num
                "
              >
                03
              </div>

              <h3>
                Producer Verdict
              </h3>

              <p>
                Roundtables report findings ·
                independent judges score ·
                Farm Awards presented ·
                commercialization pathways
                identified
              </p>

            </div>

          </div>


          <div
            className="
              s-ftac-cta
            "
          >

            <button
              type="button"

              className="
                btn-og3
              "

              onClick={
                openRegistration
              }
            >
              Register for FTAC™
            </button>

          </div>

        </div>

      </div>


      {/* =====================================================
          VENUE
          ===================================================== */}

      <div className="s-venue">

        <div
          className="
            s-venue-inner
          "
        >


          <div className="s-v">

            <div className="s-v-label">
              Venue
            </div>

            <div className="s-v-val">
              Raising Nebraska
            </div>

            <div className="s-v-sub">
              Grand Island,
              Nebraska 68801
            </div>

          </div>


          <div className="s-v">

            <div className="s-v-label">
              Date
            </div>

            <div className="s-v-val">
              November 17, 2026
            </div>

            <div className="s-v-sub">
              8:00 AM – 6:30 PM
            </div>

            <div className="s-v-val">
              November 18, 2026
            </div>

            <div className="s-v-sub">
              8:00 AM – 12:00 PM
            </div>

          </div>


          <div className="s-v">

            <div className="s-v-label">
              Hosted by
            </div>

            <div className="s-v-val">
              Spur Ventures at UNL
            </div>

            <div className="s-v-sub">
              University of
              Nebraska–Lincoln
            </div>

          </div>


          <div className="s-v">

            <div className="s-v-label">
              Parking
            </div>

            <div className="s-v-val">
              Free on-site
            </div>

            <div className="s-v-sub">
              ADA accessible ·
              WiFi included
            </div>

          </div>


          <div className="s-v">

            <div className="s-v-label">
              Catering
            </div>

            <div className="s-v-val">
              Breakfast &amp; lunch
            </div>

            <div className="s-v-sub">
              Included with registration
            </div>

          </div>

        </div>

      </div>


      {/* =====================================================
          CLOSING CTA
          ===================================================== */}

      <div className="s-cta">

        <h2>
          Join AgConverge '26
        </h2>


        <p>
          The result is more than a conference —
          a platform for validation, adoption,
          ecosystem building, and investment in
          the Midwest&apos;s agricultural future.
        </p>


        <div
          className="
            s-cta-chips
          "
        >

          <span className="s-chip">
            <i className="fas fa-check" />
            Lunch included
          </span>


          <span className="s-chip">
            <i className="fas fa-check" />
            Live FTAC™
          </span>


          <span className="s-chip">
            <i className="fas fa-check" />
            Robotics arena
          </span>


          <span className="s-chip">
            <i className="fas fa-check" />
            Women in Ag Forum
          </span>


          <span className="s-chip">
            <i className="fas fa-check" />
            Farm Awards
          </span>

        </div>


        <button
          type="button"

          className="
            btn-og3
          "

          style={{
            fontSize:
              '15px',

            padding:
              '14px 36px',
          }}

          onClick={
            openRegistration
          }
        >
          Register Now
        </button>

      </div>

    </>

  );

};


export default HarvestHorizonHero;